module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "started_wrapper"
  }, [_c('div', {
    staticClass: "download"
  }, [_c('ul', [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "started_container"
  }, [_c('img', {
    attrs: {
      "src": require("@img/stared_bird.png"),
      "alt": "bird"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("You're ready to become a HAWO teacher. We're excited to have you on our team, and we hope that you'll enjoy your experience with us!\n\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "started",
    on: {
      "click": _vm.letUsBegin
    }
  }, [_vm._v("Let's get started!")]), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("Please click on the button below to launch.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e5700b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/get_started.vue
// module id = 838
// module chunks = 1